import React from 'react'

const BarangayFooter = ({ barangay }) => {
  if (!barangay.updated_at) return null

  // Format the date to a readable format
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', options)
  }

  return (
    <section className="section" style={{ paddingTop: '20px', paddingBottom: '20px', backgroundColor: '#f8f9fa' }}>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <p style={{ marginBottom: 0, color: '#6c757d', fontSize: '0.9rem' }}>
              <em className="fas fa-clock me-2"></em>
              Last updated: {formatDate(barangay.updated_at)}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BarangayFooter
